'use strict';
import angular from 'angular';
import EducationSubNavController from './education-sub-nav.controller';
import util from '../util/util.module';
export default angular.module('directives.educationSubNav', [util])
    .controller('EducationSubNavController', EducationSubNavController)
    .component('educationSubNav', {
    template: require('./education-sub-nav.html'),
    controller: EducationSubNavController,
    bindings: {
        value: '=',
        pagetype: '@',
        selectedpageindex: '='
    }
})
    .name;
//# sourceMappingURL=index.js.map